import axios from "axios";
import React, { Component } from "react";
import { Spinner } from "react-bootstrap";
import Credentials, {
  currentTenant,
  roles,
  thousandsdisplay,
  usertoken,
} from "../Common/Credentials";
import Permissions from "../Common/Permissions";
import Products from "../Common/Products";
import MasterService from "../Masters/MasterService";
import UserService from "../users/UserService";
import AuthenticationService from "./AuthenticationService";
import Eye from "../users/Eye";
import FileServices from "../Common/upload/FileServices";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";
import çoverimg from "../images/cover.png";
import finanzzlogo from "../images/Finanzz.png";
import Swal from "sweetalert2";
import moment from "moment";
import { Navigate } from "react-router-dom";
import "./Login.css";
import Subscription from "./Subscription";
import PricingSection from "./PricingSection";
let permissionlist;
let productslist;
let logopath;
let logofile;
let zoneid;
let initialsetup;
import NewERPLogo from '../images/Finanzzi.png';
import NewERPbg from '../images/360 Degree Erp Logo.png';
import NewERPSec1 from '../images/SecureLogin1.png';
import NewERPSec2 from '../images/SecuredLogin2.png';
import { toast } from "../NewUI/NewComponents/toastService";
import Button from "../NewUI/NewComponents/Button";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usernameOrEmail: "",
      password: "",
      errormsg: "",
      showSuccessMesage: false,
      hasLoginFailed: false,
      TenantID: "",
      prefix: "",
      clientname: "",
      loginuserid: "",
      userroles: [],
      UserPermission: "",
      Ipaddress: "",
      userid: "",
      loader: false,
      type: "password",
      logopath: "",
      logofile: "",
      isubscribed: false,
      adminUserExits: 0,
      daysremaining: 0,
      activeSlide: 0
    };
    this.handleChange = this.handleChange.bind(this);
    this.loginClicked = this.loginClicked.bind(this);
    this.pageloaded = this.pageloaded.bind(this);
    this.getPermissions = this.getPermissions.bind(this);
    this.dbAssign = this.dbAssign.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
    this.passwordInput = React.createRef();
    this.loginButton = React.createRef();
  }

  handleClick = () =>
    this.setState(({ type }) => ({
      type: type === "text" ? "password" : "text",
    }));

  getData = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    this.setState({ Ipaddress: res.data.IPv4 });
  };

  handleChange(event) {
    const { name, value } = event.target;
    this.setState(
      {
        [name]: value,
        loader: false,
        hasLoginFailed: false,
        errormsg: ""
      },
      () => {
        const inputType = event.nativeEvent.inputType;
        const isAutocomplete =
          inputType === undefined ||
          inputType === null ||
          inputType === "insertReplacementText";
        if (isAutocomplete && value.length > 0) {
          setTimeout(() => {
            if (this.state.usernameOrEmail && this.state.password) {
              this.loginButton.current?.focus();
            } else if (name === "usernameOrEmail") {
              this.passwordInput.current?.focus();
            }
          }, 200);
        }
      }
    );
  }

  pageloaded() { }

  componentDidMount() {
    if (usertoken !== undefined) {
      window.location.reload(false);
    }
    this.setState({ prefix: window.location.hostname.split(".")[0] });

    this.carouselInterval = setInterval(() => {
      this.setState((prevState) => ({
        activeSlide: (prevState.activeSlide + 1) % 4
      }));
    }, 4000);
  }

  componentWillUnmount() {
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
  }

  componentDidUpdate() {
    if (this.state.clientname === "") {
      AuthenticationService.setprefix(this.state.prefix)
        .then((response) => {
          this.setState({ clientname: response.data.companyname });
          this.setState({ TenantID: response.data.id });
          UserService.settenantid(response.data.id);
        })
        .catch(() => this.props.navigate("/"));
      AuthenticationService.GetSubscriptionPackages(this.state.prefix).then(
        (response) => {
          if (response && response.data) {
            this.setState({
              isubscribed: response.data.subscribed,
              daysremaining: response.data.daysremaining,
              adminUserExits: response.data.adminUserExits
            });
          }
        }
      );
    }
  }

  loginClicked(e) {
    if (e) e.preventDefault();
    if (!this.state.usernameOrEmail && !this.state.password) {
      // this.setState({
      //   hasLoginFailed: true,
      //   errormsg: "Username and password required",
      //   loader: false
      // });
      toast("Username and password required", "error")
      return;
    }

    if (!this.state.password) {
      this.setState({
        hasLoginFailed: true,
        errormsg: "Enter password",
        loader: false
      });
      return;
    }

    this.setState({ loader: true });
    AuthenticationService.executeJwtAuthenticationService(
      this.state.usernameOrEmail,
      this.state.password,
      this.state.TenantID
    )
      .then((response) => {
        AuthenticationService.registerSuccessfullLoginForJwt(
          this.state.usernameOrEmail,
          response.data.token,
          response.data
        );
        this.setState({ loginuserid: response.data.username });
        this.setState({ userroles: response.data.roles });
        this.setState({ userid: response.data.id });
        initialsetup = response.data.initialsetup;
        zoneid = response.data.zoneid;
        logopath = response.data.logopath;
        logofile = response.data.logofile;
        let currentrole =
          response.data.roles && response.data.roles.map((id, name) => id);

        Credentials.setclientname(this.state.clientname);
        Credentials.setcurrentUser(this.state.usernameOrEmail);
        Credentials.setcurrentTenant(this.state.TenantID);
        Credentials.setuserToken(response.data.token);
        Credentials.setRoles(currentrole.toLocaleString());
        Credentials.setcurrentuserId(response.data.id);
        Credentials.setPrefix(response.data.prefix);
        Credentials.setCity(response.data.cityname);
        Credentials.setState(response.data.statename);
        Credentials.setccountry(response.data.countryname);
        Credentials.setZip(response.data.zip);
        Credentials.setCompanyemail(response.data.companyemail);
        Credentials.setContactnumber(
          response.data.phonecode + " - " + response.data.phonenum
        );
        Credentials.setcurrency(response.data.currencyname);
        Credentials.setaddress(response.data.address);
        Credentials.setaddress2(response.data.address2);
        Credentials.setcFinancialYearStart(response.data.fystartdate);
        Credentials.setFinancialYearEnd(response.data.fyenddate);
        Credentials.setTaxtype(response.data.taxtype);
        Credentials.setclienttz(response.data.zoneid);
        Credentials.setpan(response.data.pan);
        Credentials.settan(response.data.tan);
        Credentials.setgstin(response.data.gstin);
        Credentials.settaxno(response.data.taxno);
        Credentials.setregistrationno(response.data.registrationno);
        Credentials.setEinvoice(response.data.einvoice);
        Credentials.setStatecode(response.data.statecode);
        Credentials.setDataaccess(response.data.dataaccess);
        Credentials.setUserwhid(response.data.whid);
        Credentials.setNoofusers(response.data.noofusers);
        Credentials.setTransactionFrom(response.data.transactionFrom);
        Credentials.setTheme(response.data.theme);
        if (response.data.countryname === "India") {
          Credentials.thousandsdisplay("lakh");
        } else {
          Credentials.thousandsdisplay("thousand");
        }
      })
      .then(() => {
        let formData = new FormData();
        formData.append("path", logopath);
        formData.append("filename", logofile);

        FileServices.getonefile(formData)
          .then((response) => {
            let logo = URL.createObjectURL(new Blob([response.data], { type: "application/octet-stream" }))
            Credentials.setLogo(logo)
            this.getLogo(logo)
          })
          .then(() =>
            initialsetup !== "Pending"
              ? this.getPermissions()
              : this.props.navigate("/initialsetup")
          )
          .catch(() => {
            initialsetup !== "Pending"
              ? this.getPermissions()
              : this.props.navigate("/initialsetup");
          });
      })
      .catch((e) => {
        console.log(e);
        this.setState({ hasLoginFailed: true, loader: false });
        this.setState({ showSuccessMesage: false });
        // this.setState({
        //   errormsg:
        //     "An unauthorized error occurred, Please try again after sometime",
        //   loader: false
        // });
        // toast("An unauthorized error occurred, Please try again after sometime", "error")
        if (e.response?.data?.message === "User is Logged In!!") {
          Swal.fire({
            title: "User is already logged In!",
            text: "Do you want to teminate?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#152f5f",
            cancelButtonText: "No"
          }).then((result) => {
            if (result.value) {
              AuthenticationService.logout(
                this.state.usernameOrEmail,
                this.state.TenantID
              ).then((response) => {
                this.setState({
                  errormsg:
                    response.data.message === ""
                      ? response.data.error
                      : response.data.message,
                  loader: false
                });
                Swal.fire({
                  title: "Please Login !!!",
                  text: "All session Cleared Successfully.",
                  icon: "success",
                  showCancelButton: true,
                  confirmButtonText: "Sign In",
                  confirmButtonColor: "#152f5f"
                }).then((result) => {
                  if (result.value) {
                    this.loginClicked();
                  }
                });
              });
            }
          });
        }
        if (this.state.errormsg === "" && e.response.data.message) {
          // this.setState({ errormsg: e.response.data.message, loader: false });
          toast(e.response.data.message, "error")
          this.setState({ errormsg: "", loader: false });
        } else if (e?.response?.data?.error === "Unauthorized") {
          // this.setState({ errormsg: "Invalid Credentials", loader: false });
          toast("Invalid Credentials", "error")
        } else {
          // this.setState({
          //   errormsg:
          //     "An unauthorized error occurred, Please try again after sometime",
          //   loader: false
          // });
          toast("An unauthorized error occurred, Please try again after sometime", "error")
        }
      });
  }

  getLogo(logo) {
    if (!logo) return;
    let i = new Image();
    i.src = logo;

    setTimeout(() => {
      console.log("getLogoDimensions", this.getLogoDimensions(i.naturalWidth, i.naturalHeight))
      Credentials.setLogoDimensions(this.getLogoDimensions(i.naturalWidth, i.naturalHeight));
    }, 100);
  }

  getLogoDimensions(imgWidth, imgHeight, logoExists = true) {
    if (!logoExists || !imgWidth || !imgHeight) {
      return {
        width: 0,
        height: 0
      };
    }

    const aspectRatio = imgWidth / imgHeight;

    let width;
    let height;

    if (aspectRatio >= 2) {
      // Very wide landscape logo
      height = 45;
      width = height * aspectRatio;
    } else if (aspectRatio >= 1.2 && aspectRatio < 2) {
      // Normal landscape logo
      width = 60;
      height = width / aspectRatio;
    } else if (aspectRatio >= 0.7 && aspectRatio <= 1.2) {
      // Portrait / Square logo
      height = 60;
      width = 60;
    } else {
      // Tall portrait logo
      width = 45;
      height = width / aspectRatio;
    }

    // Ensure height never exceeds 60px
    if (height > 60) {
      const scale = 60 / height;
      height = 60;
      width = width * scale;
    }

    return {
      width: Number(width.toFixed(2)),
      height: Number(height.toFixed(2))
    };
  };

  getPermissions() {
    MasterService.getProducts(this.state.TenantID)
      .then((response) => {
        productslist = response.data;
        let appmaster = productslist.filter((e) =>
          e.productid === 1 ? e.productsEnabled : ""
        );
        Products.setProductAppmaster(appmaster.map((e) => e.productsEnabled));

        let auth = productslist.filter((e) =>
          e.productid === 2 ? e.productsEnabled : ""
        );
        Products.setProductAuth(auth.map((e) => e.productsEnabled));

        let accounts = productslist.filter((e) =>
          e.productid === 3 ? e.productsEnabled : ""
        );
        Products.setProductAccounts(accounts.map((e) => e.productsEnabled));

        let inventory = productslist.filter((e) =>
          e.productid === 4 ? e.productsEnabled : ""
        );
        Products.setProductInventory(inventory.map((e) => e.productsEnabled));

        let sales = productslist.filter((e) =>
          e.productid === 5 ? e.productsEnabled : ""
        );
        Products.setProductSales(sales.map((e) => e.productsEnabled));

        let purchase = productslist.filter((e) =>
          e.productid === 6 ? e.productsEnabled : ""
        );
        Products.setProductPurchase(purchase.map((e) => e.productsEnabled));

        let production = productslist.filter((e) =>
          e.productid === 7 ? e.productsEnabled : ""
        );
        Products.setProductProduction(production.map((e) => e.productsEnabled));

        let asset = productslist.filter((e) =>
          e.productid === 8 ? e.productsEnabled : ""
        );
        Products.setProductAssetmanagement(asset.map((e) => e.productsEnabled));

        let salestravel = productslist.filter((e) =>
          e.productid === 10 ? e.productsEnabled : ""
        );
        Products.setSalesTravels(salestravel.map((e) => e.productsEnabled));
      })
      .then(() => {
        UserService.UserPermissions(this.state.userid).then((response) => {
          permissionlist = response.data.permissionlist;
          let appmasterid = permissionlist.filter((e) => e.productid === 1);
          Permissions.setAppmaster(appmasterid.map((e) => e.permission));

          let authid = permissionlist.filter((e) => e.productid === 2);
          Permissions.setAuth(authid.map((e) => e.permission));

          let accountsid = permissionlist.filter((e) => e.productid === 3);
          Permissions.setAccounts(accountsid.map((e) => e.permission));

          let inventoryid = permissionlist.filter((e) => e.productid === 4);
          Permissions.setInventory(inventoryid.map((e) => e.permission));

          let salesid = permissionlist.filter((e) => e.productid === 5);
          Permissions.setSales(salesid.map((e) => e.permission));

          let purchaseid = permissionlist.filter((e) => e.productid === 6);
          Permissions.setPurchase(purchaseid.map((e) => e.permission));

          let productionid = permissionlist.filter((e) => e.productid === 7);
          Permissions.setProduction(productionid.map((e) => e.permission));

          let assetid = permissionlist.filter((e) => e.productid === 8);
          Permissions.setAssetmanagement(assetid.map((e) => e.permission));
        });
      });
    MasterService.getallRoles(currentTenant)
      .then((response) => {
        Products.setScreens(response.data.filter((e) => e.name === roles));
      })
      .then(() => this.dbAssign());
  }

  dbAssign() {
    this.props.navigate("/index");
  }

  handleKeypress = (e) => {
    if (e.which === 13) {
      this.loginClicked(e);
    }
  };

  handleForgotPassword = () => {
    Swal.fire({
      title: "Please Enter Username Or Email!!!",
      text: "",
      icon: "error"
    });
  };

  handleSubscriptionChange = () => {
    this.setState({ isubscribed: true });
  };

  render() {
    const is360 = process.env.REACT_APP_FINANZZ_URL === "360";
    const primaryColor = is360 ? "#390098" : "#062533";
    const clientname = this.state.clientname;
    let displayclient;
    if (clientname === "") {
      displayclient = <p className="text-danger">Invalid Domain. Please check </p>;
    } else {
      displayclient = (
        <>
          <p className="brand-text fs-15 popinsbold text-bold mb-1 text-white">
            WELCOME BACK
          </p>
          <h5 className="fs-20 popinsbold text-bold text-yellow brand-text">
            {this.state.clientname.toUpperCase()}
          </h5>
        </>
      );
    }
    return (
      <div
        className={`tw-relative ${is360 ? "form2" : "form1"} tw-overflow-hidden`}
      >
        {this.state.isubscribed === true && this.state.TenantID ? (
          <form
            className="overflow-hidden form"
            onSubmit={(e) => e.preventDefault()}
          >
            <meta charSet="utf-8" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            <title>AdminLTE 3 | Log in</title>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <link
              rel="stylesheet"
              href="../../plugins/fontawesome-free/css/all.min.css"
            />
            <link
              rel="stylesheet"
              href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
            />
            <link
              rel="stylesheet"
              href="../../plugins/icheck-bootstrap/icheck-bootstrap.min.css"
            />
            <link rel="stylesheet" href="../../dist/css/adminlte.min.css" />
            <link
              href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700"
              rel="stylesheet"
            />
            <div className="m-auto tw-min-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center">
              <div
                className="d-flex align-items-center justify-content-center tw-w-full"
              >
                <div
                  className="col-lg-7 d-flex p-0"
                  style={{ height: "450px", gap: "10px" }}
                >
                  {/* Left Side: Form */}
                  <div
                    className="tw-bg-white tw-shadow-lg rounded-lg px-4 d-flex flex-column align-items-center justify-content-center text-left "
                    style={{ width: "calc(50% - 10px)" }}
                  >
                    <img
                      src={is360 ? NewERPbg : NewERPLogo}
                      alt="Logo..."
                      height="60"
                      className="finanzzlogo tw-h-[80px] align-self-start"
                    />

                    <div className="tw-w-[85%] d-flex flex-column align-items-start">
                      <span className="tw-text-black p-2  tw-text-[12px] tw-font-bold">
                        Sign-in to your ERP system
                      </span>
                      <span className="tw-text-black pl-2 pb-2 tw-text-[12px] tw-leading-tight tw-font-bold">
                        {this.state.clientname.toUpperCase()}
                      </span>

                      <div className="input-group tw-text-[13px] mb-3">
                        <input
                          type="text"
                          name="usernameOrEmail"
                          autoComplete="username"
                          value={this.state.usernameOrEmail}
                          onChange={this.handleChange}
                          onKeyPress={this.handleKeypress}
                          className={`input text-semibold w-100 tw-py-4 ${this.state.hasLoginFailed &&
                            (this.state.errormsg
                              .toLowerCase()
                              .includes("username") ||
                              this.state.errormsg.toLowerCase().includes("required"))
                            ? "input-error"
                            : ""
                            }`}
                          placeholder="USER ID"
                        />
                      </div>

                      {/* Password field with eye icon */}
                      <div className="input-group mb-3 position-relative tw-text-[13px] w-100">
                        <input
                          type={this.state.type}
                          name="password"
                          autoComplete="current-password"
                          ref={this.passwordInput}
                          onKeyPress={this.handleKeypress}
                          value={this.state.password}
                          onChange={this.handleChange}
                          className={`input text-semibold w-100 tw-py-4 ${this.state.hasLoginFailed &&
                            (this.state.errormsg
                              .toLowerCase()
                              .includes("password") ||
                              this.state.errormsg.toLowerCase().includes("required"))
                            ? "input-error"
                            : ""
                            }`}
                          placeholder="PASSWORD"
                        />
                        <span
                          className="eye"
                          style={{ color: primaryColor }}
                          onClick={this.handleClick}
                        >
                          <Eye />
                        </span>
                      </div>

                      {/* {this.state.hasLoginFailed && (
                        <div className="alert login-alert text-xs w-100">
                          {this.state.errormsg}
                        </div>
                      )} */}
                      <div className="mb-1 w-100">
                        {this.state.loader === true ? (
                          <Button
                            className="tw-w-full"
                            // style={{ backgroundColor: primaryColor, height: "32px" }}
                            disabled
                            variant="primary"
                          >
                            <Spinner
                              animation="border"
                              size="sm"
                              className="mr-2"
                            />
                            Loging in...
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            variant="primary"
                            className={"tw-w-full"}
                            ref={this.loginButton}
                            // className="UI-btn UI-btn-primary tw-w-full"
                            // style={{ backgroundColor: primaryColor, height: "32px" }}
                            onClick={this.loginClicked}
                          >
                            Login
                          </Button>
                        )}
                      </div>
                      <div className="text-left w-100">
                        {this.state.usernameOrEmail === "" ? (
                          <span
                            className="cursorPointer"
                            onClick={this.handleForgotPassword}
                          >
                            <p
                              style={{ color: primaryColor, fontSize: 12 }}
                              className="tw-italic mb-0"
                            >
                              Forgot password ?
                            </p>
                          </span>
                        ) : (
                          <Link
                            to={{ pathname: "/forgotpassword" }}
                            state={{
                              username: this.state.usernameOrEmail,
                              clientname: this.state.clientname,
                              clientid: this.state.TenantID
                            }}
                          >
                            <p
                              style={{ color: primaryColor, fontSize: 12 }}
                              className="tw-italic mb-0"
                            >
                              Forgot password ?
                            </p>
                          </Link>
                        )}
                      </div>
                      {!is360 &&
                        <div className="tw-mt-3 tw-text-[12px] tw-text-gray-600 text-left w-100">
                          <span className="tw-italic">
                            Still don't have {is360 ? "360° ERP" : "FINANZZ ERP"}{" "}
                            account?{" "}
                          </span>{" "}
                          <Link
                            to="/signup"
                            className="tw-font-bold"
                            style={{ color: primaryColor }}
                          >
                            Signup
                          </Link>
                        </div>}
                    </div>
                  </div>

                  {/* Right Side: Image/Design - with crossfade transition */}
                  <div
                    className="tw-bg-white tw-shadow-lg rounded-lg overflow-hidden position-relative"
                    style={{ width: "calc(50% - 10px)", height: "450px" }}
                  >
                    {/* Slide 1: Tenant based Secured login */}
                    <div
                      className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center p-4"
                      style={{
                        opacity: this.state.activeSlide % 2 === 0 ? 1 : 0,
                        transition: "opacity 0.6s ease-in-out",
                        pointerEvents:
                          this.state.activeSlide % 2 === 0 ? "auto" : "none"
                      }}
                    >
                      <div className="tw-w-[85%] d-flex flex-column">
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <div className="col-7 p-0">
                            <h5
                              className="tw-font-semibold tw-text-black tw-text-[20px] tw-leading-[1.1] mb-2"
                              style={{ maxWidth: "180px" }}
                            >
                              Tenant based Secured login
                            </h5>
                            <p
                              className="tw-text-[12px] tw-leading-tight tw-italic m-0"
                              style={{ color: primaryColor, maxWidth: "260px" }}
                            >
                              We manage secure user logins with 3D authentication
                              and OTP verification.
                            </p>
                          </div>
                          <div
                            className="col-6 p-0 d-flex justify-content-end align-items-center"
                            style={{ height: "250px" }}
                          >
                            <img
                              src={NewERPSec1}
                              alt="Security..."
                              style={{
                                height: "200px",
                                objectFit: "contain",
                                width: "100%"
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Slide 2: Passwordless Access */}
                    <div
                      className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center p-4"
                      style={{
                        opacity: this.state.activeSlide % 2 === 1 ? 1 : 0,
                        transition: "opacity 0.6s ease-in-out",
                        pointerEvents:
                          this.state.activeSlide % 2 === 1 ? "auto" : "none"
                      }}
                    >
                      <div className="tw-w-[85%] d-flex flex-column">
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <div className="col-7 p-0">
                            <h5
                              className="tw-font-semibold tw-text-black tw-text-[20px] tw-leading-[1.1] mb-2"
                              style={{ maxWidth: "180px" }}
                            >
                              Passwordless Access
                            </h5>
                            <p
                              className="tw-text-[12px] tw-leading-tight tw-italic m-0"
                              style={{ color: primaryColor, maxWidth: "210px" }}
                            >
                              Log in securely without a password using your device
                              fingerprint or one-time verification.
                            </p>
                          </div>
                          <div
                            className="col-6 p-0 d-flex justify-content-end align-items-center"
                            style={{ height: "250px" }}
                          >
                            <img
                              src={NewERPSec2}
                              alt="Security..."
                              style={{
                                height: "250px",
                                objectFit: "contain",
                                width: "100%"
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Dots indicator */}
                    <div
                      className="position-absolute d-flex tw-gap-3 align-items-center justify-content-center"
                      style={{ bottom: "70px", left: 0, right: 0 }}
                    >
                      {[80, 60, 40, 25].map((width, index) => (
                        <div
                          key={index}
                          style={{
                            width: `${width}px`,
                            height: "4px",
                            borderRadius: "8px",
                            backgroundImage:
                              "linear-gradient(to right, #c7ddf3, #148fce, #110153)",
                            opacity: this.state.activeSlide === index ? 1 : 0.3,
                            transition: "opacity 0.3s ease"
                          }}
                          className="tw-transition-all tw-duration-500"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-100">
                <div className="d-flex justify-content-around py-2">
                  <div className="text-black tw-font-bold">
                    <span className="fs-12" style={{ fontSize: 12 }}>
                      {is360
                        ? "COPYRIGHT@2026 360 ENTERPRISE RESOURCE PLANNING"
                        : "PRODUCT OF JNANA SOFTWARE TECHNOLOGIES PRIVATE LIMITED"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        ) : (
          this.state.TenantID && (
            <>
              <div className="tw-flex tw-justify-center tw-items-center tw-backdrop-filter tw-backdrop-blur-xl tw-bg-opacity-60  tw-duration-200 tw-transform tw-w-full tw-h-full">
                <div className="">
                  <PricingSection handleSubscriptionChange={this.handleSubscriptionChange} TenantID={this.state.TenantID} adminUserExits={this.state.adminUserExits} />
                </div>
              </div>
            </>
          )
        )}
      </div>
    );
  }
}
export default withRouter(Login);